import React, { Suspense } from "react";

import Spinner from "../../../../components/spinner.components";
import { useParams } from "react-router-dom";
import {
  PostStatus,
  type IPost,
} from "../../../../types/models/post.models.types";
import { useToast } from "../../../../hooks/use-toast";
import { handleHttpError } from "../../../../utils/utils";
import { useGetPostByIdHttp } from "../../../hooks/http/posts/get-post-by-id.hook";
import { InstagramEmbed } from "react-social-media-embed";
import { PostAction } from "../../../components/core/post-action.core";
import RejectionCard from "../../../components/core/rejection-card.core";

export const CampaignPostDetailsPartial: React.FunctionComponent = () => {
  const { postId } = useParams();
  const { execute: getPostByIdHttp, fetching: fetchingPost } =
    useGetPostByIdHttp();
  const [postData, setPostData] = React.useState<IPost>();
  const { toast } = useToast();

  async function getPost() {
    if (postId) {
      const response = await getPostByIdHttp({
        body: null,
        pathParams: { postId },
      });
      if (!response.success) {
        return handleHttpError(response, toast);
      }
      setPostData(response.data.post);
    }
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  React.useEffect(() => {
    getPost();
  }, [postId]);

  return fetchingPost ? (
    <div className="flex justify-center items-center w-full h-full">
      <Spinner width={30} />
    </div>
  ) : (
    postData && (
      <div className="flex flex-col px-5 pb-10 w-full font-cabinetgrotesk text-black">
        <div className="flex items-center gap-6 py-4 w-full">
          <img
            src="/static/profile.png"
            className="rounded-xl"
            width={72}
            height={72}
            alt=""
          />
          <span className="font-semibold text-3xl">
            {postData.creator?.name}
          </span>
        </div>
        <div className="border-t w-full" />

        <div className="py-5">
          {postData.postStatus.status === PostStatus.draftRejected && (
            <RejectionCard
              status={PostStatus.draftRejected}
              message={postData.postStatus.message || ""}
            />
          )}
          {postData.postStatus.status === PostStatus.flaggedReview && (
            <RejectionCard
              status={PostStatus.flaggedReview}
              message={postData.postStatus.message || ""}
            />
          )}
        </div>

        <div className="my-5 border rounded-xl w-full overflow-hidden">
          <div className="relative flex justify-center items-center w-full">
            {/* biome-ignore lint/a11y/useMediaCaption: <explanation> */}
            <video
              controls={true}
              src={postData.draftAsset?.url}
              className="w-full h-fit cursor-pointer object-contain"
            />
          </div>
          <div className="flex flex-col px-6 pt-5 pb-8 w-full font-semibold text-base">
            <p>{postData.draftDescription}</p>
          </div>
        </div>
       
        {postData.liveUrl && (
          <div className="w-full overflow-hidden">
            <Suspense fallback={<Spinner width={20} />}>
              <InstagramEmbed
                className="w-full"
                url={postData.liveUrl}
                captioned={true}
              />
            </Suspense>
          </div>
        )}
        <PostAction post={postData} />
      </div>
    )
  );
};
